import { connect } from 'react-redux';
import {
  pinOrUnpinContentAction,
  onRestart,
} from '../../reducers/course.reducers';
import Tile from './tilev3';

const mapDispatchToProps = (dispatch) => ({
  onRestart: () => dispatch(onRestart()),
  pinOrUnpinContent: (bulletinBoardId, pinningDto) =>
    dispatch(pinOrUnpinContentAction({ bulletinBoardId, pinningDto })),
});

const mapStateToProps = (state) => ({
  config: state.authentication.config,
  bulletinBoard: state.courses.bulletinBoard,
});

export default connect(mapStateToProps, mapDispatchToProps)(Tile);



// WEBPACK FOOTER //
// ./src/app/components/tile/tilev3.container.js